export const getGxPStatusBadgeConfig = (status?: string) => {
  const value = status?.toLowerCase()?.trim();

  const warningStatuses = ['awaiting data', 'to review', 'missing'];
  const successStatuses = ['approved', 'published', 'full', 'none'];

  if (warningStatuses.includes(value || '')) {
    return {
      bgColor: '#FDF2DC',
      textColor: '#9F6402',
    };
  }

  if (value === 'rejected' || value.includes('excursion')) {
    return {
      bgColor: '#FFF0EE',
      textColor: '#BB032A',
    };
  }

  if (successStatuses.includes(value || '')) {
    return {
      bgColor: '#EAF6ED',
      textColor: '#166C3B',
    };
  }

  return {
    bgColor: '#F5F5F5',
    textColor: '#595959',
  };
};
